import React from "react";
import styled from "styled-components";
import title from "../img/title-schedule.svg";
import device from "../helpers/device";
import Schedule from "./ScheduleRow";
import Modal from "./Modal";
import { Route } from "react-router-dom";
import ExtraSchedule from "./ExtraSchedule";

export default class ScheduleRoot extends React.Component {
  render() {
    const { schedules, entities } = this.props.store;
    return (
      <Root>
        <Route
          exact
          path="/sessions/:sessionId"
          render={props => <Modal store={this.props.store} {...props} />}
        />
        <Title>
          <img src={title} alt="Schedule" width="190" />
        </Title>
        <ExtraSchedule
          time={0}
          title="開会の挨拶：藤田 晋　/　基調講演：長瀬 慶重"
        />
        {schedules.map((scheduleId, idx) => (
          <Schedule
            key={scheduleId}
            store={this.props.store}
            data={entities.schedules[scheduleId]}
            scheduleId={scheduleId}
          />
        ))}
        <Schedule />
        <ExtraSchedule last time={9} title="クロージングトーク：長瀬 慶重" />
      </Root>
    );
  }
}

const Root = styled.div`
  margin-top: 50px;
  @media ${device.mobileL} {
    margin-top: 100px;
  }
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  position: relative;
  @media ${device.mobileL} {
    margin-bottom: 60px;
  }
`;
